import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../i18n/i18n';
import { toast } from 'react-toastify';
//import { deleteSector } from '../../actions/sectors/SectorActions';
import { deleteSector, getSectors } from '../../actions/sectors/SectorsActions';
import { wentWrong } from "../../utils/ToastConfig";
import axios from '../../utils/AxiosWrapper';
import { Delete } from '../../utils/Delete';
import AddSector from './AddSector';
import css from './viewSectors.module.css';
import AddIcon from '@material-ui/icons/Add';
import SearchBar from 'material-ui-search-bar';
import { Tooltip as Tooltip2 } from '@material-ui/core';
import { Button, Tooltip, IconButton, Menu } from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import { PulseLoader } from 'react-spinners';
import { withStyles } from '@material-ui/core/styles';

const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: '#04764e',
    color: "#ffff",

};

const styles = theme => ({
    primaryMain: { backgroundColor: theme.palette.primary.main },
    paginationButton: {
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#5EB3E4',
        color: 'white',
        border: 'none',
        cursor: 'pointer'
    },
    headerStyle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        paddingTop: 10,
        paddingBottom: 10
    },
});

class ViewSectors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workplaceType: [], groupType: [], sectorType: [],
            showFilters: false, load: false,
            page: 0, pageSize: 10, sorted: null, filtered: null,
            selection: [], selectAll: false, selectedRow: [],
            totalPages: 0, totalSectors: 0,
            add: false, edit: false, delete: false,
            data: [],
            //----------
            editObject: null,
            searchBarValue: "",
            deleteItemId: -1,
            selectedSector: "",
            sectors: [],
        };
    }

    componentDidMount() {
        this.getByURL('sector/filter_sector', 'sectorType');   //??
        this.getSectors();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchBarValue !== this.state.searchBarValue ||
            prevState.selectedSector !== this.state.selectedSector
        ) {
            this.setState({
                load: true
            })
            this.reactTable.fireFetchData();
        }
    }

    getData(state) {
        this.setState({ load: true, data: [] });

        let filtered = [...state.filtered];

        if (this.state.searchBarValue) {
            filtered.push({ id: 'naziv', value: this.state.searchBarValue });
        }


        axios.get(`api/sektor/read`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: filtered }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    totalSectors: res.data.total,
                    load: false
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }

    getSectors(edit) {
        axios.get(`api/sektor/drop_down`)
            .then(res => {
                const sectorsFromApi = res.data.data
                    .map(item => ({ id: item.id, value: item.naziv }));
                if (edit) {
                    let sectorsForEdit = sectorsFromApi;
                    let temp = [...this.state.sectors];
                    for (let i = 0; i < sectorsForEdit.length; i++) {
                        let element = sectorsForEdit[i];
                        if (!temp.some(item => item.id === element.id)) {
                            temp.push(element);
                        }
                    }
                    this.setState({
                        sectors: temp,
                    });
                } else {
                    this.setState({
                        sectors: sectorsFromApi
                    });
                }
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            });
    }

    handleOpenNewSector = () => {
        // this.setState({ add: true });
        // if (this.state.edit == false) {
        //     this.setState({
        //         editObject: null
        //     })
        // }
        this.setState({
            add: true,
            edit: false,
            editObject: null,

            //data: null // ili data: { naziv: '' }
        });
    };

    handleCloseNewSector = () => {
        this.setState({ add: false });
    }

    handleEditSector = (sector) => {
        this.setState({
            add: true,
            edit: true,
            editObject: sector,
           // data: sector
        });
    };

    onCreate = () => {
        // Zatvori modal i resetuj status pre osvežavanja podataka
        this.setState({
            add: false,
            load: true,
            edit: false,
            page: 0  // Postavi page na 0 u state ako koristiš tu vrednost u getData
        }, () => {
            this.getSectors();
            // Pozovi ponovno učitavanje podataka iz API-ja za tabelu
            if (this.reactTable && this.reactTable.fireFetchData) {
                this.reactTable.fireFetchData();
            }
        });
    };

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    }

    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal,
        });
    }

    async countTablesBySektorId(id) {
        let count;
        await axios.post('api/sektor/count_by_sector_id', { id: id })
            .then(res => {
                count = res.data.count
            })
            .catch(err => { console.log(err) })

        return count;
    }

    deleteItem = () => {
        this.props.deleteSector(this.state.selection);
        this.setState({ delete: false })
    }

    // handleDeleteSector = () => {
    //     this.props.deleteSector([this.state.deleteItemId]);
    //     this.setState({ deleteSector: false })
    //     this.getSectors();
    // }

    closeDeleteSector = () => {
        this.setState({ deleteSector: false });
        this.getSectors();
    }

    handleDeleteButtonClick = async () => {
        const id = this.state.deleteItemId;
        let count = await this.countTablesBySektorId(id);

        if (count > 0) {
            if (count === 1) {
                wentWrong(i18n.t('You cannot delete sector that has parcel on it!'));

            } else {
                wentWrong(i18n.t('You cannot delete sector that has parcels on it!'));

            }
            this.setState({ deleteSector: false });
        } else {
            await axios.post('api/sektor/delete', { selection: [id] });
            this.setState({ deleteSector: false });
            if (this.reactTable && this.reactTable.fireFetchData) {
                this.reactTable.fireFetchData();
            }
        }
    }


    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onEditClick() { this.setState({ add: !this.state.add, edit: true }); }
    // onDeleteClick = () => { this.setState({ delete: !this.state.delete }); }

    render() {
        const { classes } = this.props;

        const columns = [
            {
                Header: i18n.t('ID'),
                accessor: 'id',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Title'),
                accessor: 'naziv',
                headerStyle: commonHeaderStyle
            },
            {
                width: 80,
                Header: i18n.t('Edit'),
                accessor: 'izmena',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),

                    style: {
                        cursor: 'default'
                    }
                }),
                headerStyle: {
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: "#04764e",
                    color: '#FFFFFF'
                },
                Cell: cell => (
                    <div>
                        <Tooltip2 title={i18n.t("Edit")}>
                            {/* <IconButton aria-label="copy"
                                onClick={() => {
                                    console.log("red", cell.row._original)
                                    this.setState({
                                        edit: true,
                                        editObject: cell.row._original
                                    }, () => {
                                        this.handleOpenNewSector();
                                    });
                                }}
                            >
                                <Icons.Edit fontSize="default" />
                            </IconButton> */}
                            <IconButton aria-label="copy"
                                onClick={() => this.handleEditSector(cell.row._original)}
                            >
                                <Icons.Edit fontSize="default" />
                            </IconButton>
                        </Tooltip2>
                    </div>
                )
            },
            {
                width: 80,
                Header: i18n.t('Delete'),
                accessor: 'detalji',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: {
                        cursor: 'default'
                    }
                }),
                headerStyle: {
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: "#04764e",
                    color: '#FFFFFF'
                },
                Cell: cell => (
                    <div>
                        <Tooltip2 title={i18n.t("Delete")}>
                            <IconButton aria-label="Delete"
                                onClick={() => {
                                    this.setState({
                                        deleteItemId: cell.row._original.id,
                                        deleteSector: true
                                    });
                                }
                                    //this.onDeleteClick();
                                }>
                                <Icons.DeleteOutline fontSize="default" />
                            </IconButton>
                        </Tooltip2>
                    </div >
                )
            },
        ];
        const url = 'sector/read';

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll, isSelected, toggleSelection, toggleAll, selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit", alignItems: 'flex-end' } };
                }
                return {};
            },
            getTheadFilterProps: () => { return { style: { backgroundColor: '#58B4E5' } }; },
            getTheadTrProps: () => { return { style: { backgroundColor: '#04764e', color: '#FFFFFF' } }; },
        };

        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                    <div className={css.searchWrap}>
                        <SearchBar
                            className={css.searchBar}
                            placeholder={i18n.t('Search by name')}
                            cancelOnEscape={true}
                            value={this.state.searchBarValue}
                            onChange={(searchValue) => this.handleSearchBar(searchValue)}
                            onCancelSearch={() => this.handleSearchBar('')}
                        />

                        <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            className={css.addNewBtn}
                            onClick={() => { this.handleOpenNewSector() }}
                        >
                            <AddIcon />
                            {i18n.t('Add sector')}
                        </Button>
                    </div>
                    {/* <div className={css.filtersSection}>
                        <select className={css.dropDowns} value={this.state.selectedSector} onChange={this.handleChangeSectors} >
                            <option value="">{i18n.t('Sector')}</option>
                            {this.state.sectors && this.state.sectors.map((sector, i) => (
                                <option key={i} value={sector.id}>{sector.value}</option>
                            ))}
                        </select>
                    </div> */}
                    <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflow: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>

                        <ReactTable ref={r => (this.reactTable = r)}
                            manual
                            useSortBy
                            paging={true}
                            data={this.state.data}
                            columns={columns}
                            keyField={'id'}
                            pageRangeDisplayed={false}
                            defaultPageSize={this.state.pageSize}
                            pages={this.state.totalPages}
                            showPaginationBottom={true}
                            onFetchData={(state) => this.getData(state)}
                            previousText={'<'}
                            nextText={'>'}
                            pageText={''}
                            ofText={i18n.t('of')}
                            showPageSizeOptions={false}
                            showPagination={true}
                            rowsText={''}
                            PreviousComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            NextComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            getTrProps={() => {
                                return {
                                    style: {
                                        textAlign: 'center',
                                        paddingLeft: '10px',
                                        height: '50px',
                                        alignItems: 'center',
                                        overflowY: 'hidden',
                                        overflowX: 'hidden',
                                    }
                                };
                            }}

                            LoadingComponent={() => (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <PulseLoader loading={this.state.load} />
                                </div>
                            )}

                            onPageChange={() => {
                                this.setState({ load: true })
                            }}

                            NoDataComponent={() => (
                                <div style={{
                                    textAlign: 'center', padding: '20px', display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: -300
                                }}>
                                    {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                                </div>
                            )}
                        />
                    </div>
                </div>
                {this.state.add && <AddSector add={this.state.add} edit={this.state.edit} handleCreate={this.onCreate} handleClose={this.handleCloseNewSector} data={this.state.editObject}/>}
                {/* {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />} */}
                {this.state.deleteSector && <Delete delete={this.state.deleteSector} handleClose={this.closeDeleteSector} deleteItem={this.handleDeleteButtonClick} />}
            </>
        );
    }
}

const mapDispatchToProps = {
    deleteSector,
    getSectors
};
export default connect(null, mapDispatchToProps)(withStyles(styles)(ViewSectors));
